import DefaultLayout from '../../../layout/DefaultLayout';
import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';
import SectionWrapper from '../../../components/SectionWrapper/SectionWrapper';
import SystemOperationModeForm from '../../../components/settings/systemOperationMode/SystemOperationModeForm';

/**
 * ⚙️ SystemOperationModePage
 * ------------------------------------------------------------
 * Página principal para configurar el modo operativo del sistema.
 */
const SystemOperationModePage = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <SystemOperationModeForm />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default SystemOperationModePage;
